export default {
    brand: '매일국어T',

    // Nút chung
    buttons: {
        addAllStar: 'Tặng sao cho tất cả',
        confirm: 'Xác nhận',
        cancel: 'Hủy',
        close: 'Đóng',
        next: 'Tiếp theo',
        previous: 'Trước đó',
        start: 'Bắt đầu',
        continue: 'Tiếp tục',
        stop: 'Dừng lại',
        exit: 'Thoát',
        save: 'Lưu',
        delete: 'Xóa',
        edit: 'Chỉnh sửa',
        submit: 'Nộp',
        reset: 'Đặt lại',
        selectAll: 'Chọn tất cả',
        end: 'Kết thúc',
        assign: 'Chỉ định',
        auth: {
            login: 'Đăng nhập',
            logout: 'Đăng xuất',
        },
    },

    // Nhãn chung
    labels: {
        module: 'Hoạt động',
        lesson: 'Gói hoạt động',
        star: 'Sao khen thưởng',
        waitingRoom: 'Phòng chờ',
        taskPage: 'Đến danh sách bài tập',
        screen: 'Màn hình bảng',
        classroom: 'Lớp học',
        student: 'Học sinh',
        teacher: 'Giáo viên',
        grade: 'Khối lớp',
        school: 'Trường',
        name: 'Tên',
        date: 'Ngày',
        time: 'Thời gian',
        duration: 'Thời lượng',
        count: 'Số lượng',
        result: 'Kết quả',
        status: 'Trạng thái',
        mode: 'Chế độ',
        type: 'Loại',
        level: 'Cấp độ',
        score: 'Điểm',
        question: 'Câu hỏi',
        answer: 'Đáp án',
        online: 'Trực tuyến',
        offline: 'Ngoại tuyến',
        list: 'Danh sách',
    },

    // Tiêu đề header
    headerTitle: {
        waitingRoom: 'Phòng chờ',
    },

    // Thông báo chung
    messages: {
        confirm: 'Bạn có chắc chắn muốn {action} không?',
        success: '{action} đã hoàn thành.',
        error: 'Đã xảy ra lỗi.',
        networkError: 'Đã xảy ra lỗi mạng.',
        loading: 'Đang tải...',
        noData: 'Không có dữ liệu.',
        selectOption: 'Vui lòng chọn một tùy chọn.',
    },

    // Trạng thái
    status: {
        inProgress: 'Đang tiến hành',
        completed: 'Hoàn thành',
        pending: 'Đang chờ',
        failed: 'Thất bại',
        locked: 'Đã khóa',
        unlocked: 'Đã mở khóa',
    },

    // Môn học
    subject: {
        textbook: 'Sách giáo khoa',
        korean: 'Tiếng Hàn',
        koreanActivity: 'Hoạt động Tiếng Hàn',
        math: 'Toán',
        science: 'Khoa học',
        socialStudies: 'Xã hội',
        english: 'Tiếng Anh',
    },

    // Màn hình/Trang
    screen: {
        basic: 'Màn hình chính',
        waitingRoom: 'Phòng chờ',
        activity: 'Màn hình hoạt động',
        sessionResult: 'Màn hình kết quả buổi học',
        moduleResult: 'Màn hình kết quả hoạt động',
    },

    // Thông báo hệ thống
    system: {
        networkError: {
            title: 'Kết nối internet không ổn định.',
            message: 'Vui lòng đợi một chút...',
            refresh: 'Tải lại',
        },
        windowError: {
            closeManually: 'Đã xảy ra lỗi. Vui lòng đóng cửa sổ thủ công.',
        },
        audio: {
            playError: 'Đã xảy ra sự cố khi phát âm thanh.',
        },
    },

    // Trợ năng (alt, title, v.v.)
    accessibility: {
        alt: {
            starDraw: 'Gacha sao',
            seedLetter: 'Chữ cơ bản',
            recentSessionResult: 'Kết quả buổi học gần đây',
            questionImage: 'Hình ảnh câu hỏi',
            explanationImage: 'Hình ảnh giải thích',
            photoMaterial: 'Tài liệu ảnh',
        },
        title: {
            listen: 'Nghe âm thanh',
            fold: 'Thu gọn chủ đề viết',
            close: 'Đóng',
        },
    },

    // Đơn vị
    units: {
        minute: 'phút',
        second: 'giây',
        page: 'p',
        count: 'cái',
        person: 'người',
        person2: 'người',
        times: 'lần',
        level: 'cấp độ',
        chapter: 'tiết',
        etc: 'khác',
        vote: 'phiếu',
        notProvided: 'Chưa cung cấp',
        score: 'điểm',
    },
    // Trường hợp dùng chung từ component teacher
    common: {
        button: {
            cancel: 'Hủy',
            confirm: 'Xác nhận',
        },
    },
};
